import React, { type SVGAttributes, Suspense } from 'react'
import styled from '@emotion/styled'
import { Icons } from './library'

export type IconName = keyof typeof Icons

export type Props = {
  name: IconName
  color?: string
  size?: string | null
} & SVGAttributes<SVGSVGElement>

export const Icon: React.FC<Props> = ({
  name,
  color = 'inherit',
  size = '2rem',
  ...svgAttributes
}) => {
  const IconComponent = Icons[name]
  if (!IconComponent) return null

  return (
    <IconWrapper
      style={size === null ? { color } : { fontSize: size, width: size, height: size, color }}
    >
      <Suspense fallback={null}>
        <IconComponent.Component {...svgAttributes} />
      </Suspense>
    </IconWrapper>
  )
}

// ======
// Style
// ======

const IconWrapper = styled.span({
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,

  svg: {
    maxWidth: '100%',
    height: 'auto',
  },
})
